// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"ff7ae5f4","361":"34f6e733","405":"ee39ae97","453":"6b19f37d","469":"f2d54e74","496":"1f02ac1e","787":"5245a0b7"}[chunkId] + ".chunk.js";
};